var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4331 45L35.2109 40L29.7563 37.6263L35.2109 35.2525L37.4331 30L39.7058 35.2525L45.1604 37.6263L39.7058 40L37.4331 45Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4331 14.9495L35.2109 9.74749L29.7563 7.32324L35.2109 4.9495L37.4331 0L39.7058 4.9495L45.1604 7.32324L39.7058 9.74749L37.4331 14.9495Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3119 37.3233L10.5645 27.1212L0.1604 22.4748L10.5645 17.8283L15.3119 7.67676L20.1099 17.8283L30.4635 22.4748L20.1099 27.1212L15.3119 37.3233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.cf20e8bdc4c9af606321cdfc3cb6f10f.svg";
export { ForwardRef as ReactComponent };